// Lightbox Debug and Test Script
// Run this in the browser console to debug lightbox issues

window.LightboxDebugger = {
  // Test if lightbox elements exist
  checkElements: function () {
    console.log("🔍 Checking lightbox elements...");

    const overlay = document.getElementById("lightbox-overlay");
    const image = document.getElementById("lightbox-image");
    const close = document.getElementById("lightbox-close");
    const prev = document.getElementById("lightbox-prev");
    const next = document.getElementById("lightbox-next");
    const counter = document.getElementById("lightbox-counter");
    const altText = document.getElementById("lightbox-alt-text");
    const galleryImages = document.querySelectorAll(".product-gallery-image");
    const activeSlide = document.querySelector(".glide__slide--active");

    console.log("Results:");
    console.log("- Lightbox overlay:", overlay ? "✅ Found" : "❌ Missing");
    console.log("- Lightbox image:", image ? "✅ Found" : "❌ Missing");
    console.log("- Lightbox close:", close ? "✅ Found" : "❌ Missing");
    console.log("- Lightbox prev:", prev ? "✅ Found" : "❌ Missing");
    console.log("- Lightbox next:", next ? "✅ Found" : "❌ Missing");
    console.log("- Lightbox counter:", counter ? "✅ Found" : "❌ Missing");
    console.log("- Lightbox alt text:", altText ? "✅ Found" : "❌ Missing");
    console.log("- Gallery images:", galleryImages.length, "found");
    console.log("- Active slide:", activeSlide ? "✅ Found" : "❌ Missing");

    if (activeSlide) {
      const activeImage = activeSlide.querySelector(".product-gallery-image");
      console.log("- Active image:", activeImage ? "✅ Found" : "❌ Missing");
      if (activeImage) {
        console.log("  - Image src:", activeImage.src);
        console.log("  - Image cursor:", getComputedStyle(activeImage).cursor);
        console.log(
          "  - Image pointer-events:",
          getComputedStyle(activeImage).pointerEvents
        );
      }
    }

    return {
      overlay: !!overlay,
      image: !!image,
      close: !!close,
      counter: !!counter,
      altText: !!altText,
      galleryImages: galleryImages.length,
      activeSlide: !!activeSlide,
    };
  },

  // Test lightbox opening manually
  testOpen: function () {
    console.log("🧪 Testing lightbox open...");

    const overlay = document.getElementById("lightbox-overlay");
    const image = document.getElementById("lightbox-image");
    const activeSlide = document.querySelector(".glide__slide--active");

    if (!overlay || !image) {
      console.error("❌ Lightbox elements missing");
      return false;
    }

    if (!activeSlide) {
      console.error("❌ No active slide found");
      return false;
    }

    const activeImage = activeSlide.querySelector(".product-gallery-image");
    if (!activeImage) {
      console.error("❌ No image in active slide");
      return false;
    }

    console.log("✅ Opening lightbox with:", activeImage.src);

    image.src = activeImage.src;
    image.alt = activeImage.alt || "Test image";
    overlay.classList.add("active");
    document.body.style.overflow = "hidden";
    document.body.classList.add("lightbox-open");

    console.log("✅ Lightbox opened successfully");
    return true;
  },

  // Test lightbox closing
  testClose: function () {
    console.log("🧪 Testing lightbox close...");

    const overlay = document.getElementById("lightbox-overlay");
    if (!overlay) {
      console.error("❌ Lightbox overlay missing");
      return false;
    }

    overlay.classList.remove("active");
    document.body.style.overflow = "";
    document.body.classList.remove("lightbox-open");

    console.log("✅ Lightbox closed successfully");
    return true;
  },

  // Test lightbox navigation
  testNavigation: function () {
    console.log("🧪 Testing lightbox navigation...");

    const prev = document.getElementById("lightbox-prev");
    const next = document.getElementById("lightbox-next");
    const counter = document.getElementById("lightbox-counter");

    if (!prev || !next || !counter) {
      console.error("❌ Navigation elements missing:", {
        prev: !!prev,
        next: !!next,
        counter: !!counter,
      });
      return false;
    }

    // First open the lightbox
    if (!this.testOpen()) {
      console.error("❌ Cannot test navigation - lightbox won't open");
      return false;
    }

    console.log("✅ Testing next navigation...");
    next.click();

    setTimeout(() => {
      console.log("✅ Testing previous navigation...");
      prev.click();

      setTimeout(() => {
        console.log("✅ Navigation test complete");
        this.testClose();
      }, 500);
    }, 500);

    return true;
  },

  // Add debug borders to elements
  addDebugBorders: function () {
    console.log("🎨 Adding debug borders...");

    const overlay = document.getElementById("lightbox-overlay");
    const images = document.querySelectorAll(".product-gallery-image");

    if (overlay) {
      overlay.setAttribute("data-debug", "true");
    }

    images.forEach((img) => {
      img.setAttribute("data-debug", "true");
    });

    console.log("✅ Debug borders added");
  },

  // Remove debug borders
  removeDebugBorders: function () {
    console.log("🎨 Removing debug borders...");

    const overlay = document.getElementById("lightbox-overlay");
    const images = document.querySelectorAll(".product-gallery-image");

    if (overlay) {
      overlay.removeAttribute("data-debug");
    }

    images.forEach((img) => {
      img.removeAttribute("data-debug");
    });

    console.log("✅ Debug borders removed");
  },

  // Test image click events
  testImageClick: function (imageIndex = 0) {
    console.log("🖱️ Testing image click...");

    const images = document.querySelectorAll(".product-gallery-image");
    if (images.length === 0) {
      console.error("❌ No gallery images found");
      return false;
    }

    if (imageIndex >= images.length) {
      console.error(
        `❌ Image index ${imageIndex} out of range (0-${images.length - 1})`
      );
      return false;
    }

    const targetImage = images[imageIndex];
    console.log("🎯 Clicking image:", targetImage.src);

    // Simulate click event
    const clickEvent = new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window,
    });

    targetImage.dispatchEvent(clickEvent);

    console.log("✅ Click event dispatched");
    return true;
  },

  // Check for event listeners
  checkEventListeners: function () {
    console.log("🔗 Checking event listeners...");

    const images = document.querySelectorAll(".product-gallery-image");
    const overlay = document.getElementById("lightbox-overlay");
    const close = document.getElementById("lightbox-close");

    console.log("Event listener check:");
    console.log("- Gallery images with click events:", images.length);
    console.log("- Lightbox overlay:", overlay ? "Found" : "Missing");
    console.log("- Close button:", close ? "Found" : "Missing");

    // Test if images respond to clicks
    images.forEach((img, index) => {
      const hasClickListener =
        img.onclick !== null || img.addEventListener !== undefined;
      console.log(
        `  - Image ${index + 1}: ${
          hasClickListener ? "Has events" : "No events"
        }`
      );
    });
  },

  // Force reinitialize lightbox
  forceReinit: function () {
    console.log("🔄 Force reinitializing lightbox...");

    // Try to call the global debug function if available
    if (window.debugLightbox) {
      window.debugLightbox();
    } else {
      console.warn("⚠️ Global debugLightbox function not available");
    }

    // Try to call the test click function
    if (window.testLightboxClick) {
      window.testLightboxClick();
    } else {
      console.warn("⚠️ Global testLightboxClick function not available");
    }
  },

  // Check for elements with high z-index that might interfere
  checkZIndexConflicts: function () {
    console.log("🔍 Checking for z-index conflicts...");

    const allElements = document.querySelectorAll("*");
    const highZIndexElements = [];

    allElements.forEach((el) => {
      const zIndex = getComputedStyle(el).zIndex;
      if (zIndex !== "auto" && parseInt(zIndex) > 1000) {
        highZIndexElements.push({
          element: el,
          zIndex: parseInt(zIndex),
          tagName: el.tagName,
          className: el.className,
          id: el.id,
        });
      }
    });

    // Sort by z-index descending
    highZIndexElements.sort((a, b) => b.zIndex - a.zIndex);

    console.log(
      `Found ${highZIndexElements.length} elements with z-index > 1000:`
    );
    highZIndexElements.forEach((item) => {
      console.log(
        `- ${item.tagName}${item.id ? "#" + item.id : ""}${
          item.className ? "." + item.className.split(" ").join(".") : ""
        }: z-index ${item.zIndex}`
      );
    });

    const lightboxOverlay = document.getElementById("lightbox-overlay");
    if (lightboxOverlay) {
      const lightboxZIndex = getComputedStyle(lightboxOverlay).zIndex;
      console.log(`Lightbox z-index: ${lightboxZIndex}`);

      const conflictingElements = highZIndexElements.filter(
        (item) => item.zIndex >= parseInt(lightboxZIndex)
      );
      if (conflictingElements.length > 0) {
        console.warn(
          `⚠️ ${conflictingElements.length} elements have z-index >= lightbox z-index!`
        );
        console.log("Conflicting elements:", conflictingElements);
      } else {
        console.log("✅ No z-index conflicts detected");
      }
    }

    return highZIndexElements;
  },

  // Run all tests
  runAllTests: function () {
    console.log("🧪 Running all lightbox tests...");
    console.log("================================");

    this.checkElements();
    console.log("");

    this.checkEventListeners();
    console.log("");

    this.checkZIndexConflicts();
    console.log("");

    this.addDebugBorders();
    console.log("");

    console.log("🎯 Manual tests available:");
    console.log("- LightboxDebugger.testOpen() - Test opening lightbox");
    console.log("- LightboxDebugger.testClose() - Test closing lightbox");
    console.log("- LightboxDebugger.testNavigation() - Test navigation arrows");
    console.log(
      "- LightboxDebugger.testImageClick(0) - Test clicking first image"
    );
    console.log("- LightboxDebugger.forceReinit() - Force reinitialize");
    console.log(
      "- LightboxDebugger.checkZIndexConflicts() - Check z-index conflicts"
    );
    console.log(
      "- LightboxDebugger.removeDebugBorders() - Remove debug borders"
    );
  },
};

// Auto-run basic checks when script loads
console.log("🔧 Lightbox Debugger loaded");
console.log("Run LightboxDebugger.runAllTests() to start debugging");
